import React from 'react';
import PropTypes from 'prop-types';
import Icon, { IconSizes } from '../../components/foundations/Icon';
import PromptTitleEditor from './PromptTitleEditor';
import { TRANSLATION_KEY } from '../constants';

const EditablePrompt = ({
    isEditing,
    onEditStart,
    onEditDone,
    prompt,
    onSave,
    rowClassName,
    textClassName,
    editorClassName,
    iconSize,
    iconClassName = '',
}) =>
    isEditing ? (
        <div className={editorClassName} onClick={e => e.stopPropagation()}>
            <PromptTitleEditor initialValue={prompt} onSave={onSave} onDone={onEditDone} />
        </div>
    ) : (
        <div className={rowClassName}>
            <div className={textClassName}>{prompt}</div>
            <Icon
                name="pencil"
                size={iconSize}
                className={iconClassName}
                hoverText={`${TRANSLATION_KEY}.MENU.EDIT_PROMPT`}
                onClick={e => {
                    e.stopPropagation();
                    onEditStart();
                }}
            />
        </div>
    );

EditablePrompt.propTypes = {
    isEditing: PropTypes.bool.isRequired,
    onEditStart: PropTypes.func.isRequired,
    onEditDone: PropTypes.func.isRequired,
    prompt: PropTypes.string.isRequired,
    onSave: PropTypes.func.isRequired,
    rowClassName: PropTypes.string.isRequired,
    textClassName: PropTypes.string.isRequired,
    editorClassName: PropTypes.string.isRequired,
    iconSize: PropTypes.oneOf(Object.values(IconSizes)).isRequired,
    iconClassName: PropTypes.string,
};

export default EditablePrompt;
